import "../sass/theme.scss";

(function ($) {
	"use strict";

	// Scroll-based header visibility handler
	function initHeaderScroll() {
		const $nav = $(".main-navigation");
		if (!$nav.length) return;

		let lastScroll = 0;
		let rafId = null;
		const threshold = 90;

		const updateHeader = () => {
			const current = window.pageYOffset || document.documentElement.scrollTop;
			const scrollingDown = current > lastScroll && current > threshold;

			$nav
				.toggleClass("navbar-hidden", scrollingDown)
				.toggleClass("navbar-visible", !scrollingDown);
			lastScroll = current;
			rafId = null;
		};

		const onScroll = () => {
			if (!rafId) {
				rafId = requestAnimationFrame(updateHeader);
			}
		};

		$nav.addClass("navbar-visible");
		window.addEventListener("scroll", onScroll, { passive: true });
	}

	// Carousel functionality
	function initCarousel() {
		const $carousel = $(".we-carousel");
		if (!$carousel.length) return;

		let currentCardIndex = 0;
		const cards = $(".we-card");
		const totalCards = cards.length;

		if (totalCards === 0) return;

		// Initial state: Set all cards to initial state, show first card
		function setInitialState() {
			cards.removeClass(
				"active prev-1 next-1 prev-2 next-2 prev-3 next-3 initial-active"
			);
			cards.addClass("initial-state");

			// Show first card in center
			$(cards[0]).removeClass("initial-state").addClass("initial-active");
		}

		// Animate cards from center to their positions
		function animateToPositions() {
			cards.removeClass("initial-state initial-active");

			// Small delay to ensure smooth transition
			setTimeout(function () {
				updateCarousel();
			}, 100);
		}

function updateCarousel() {
    cards.removeClass(
        "active prev-1 next-1 prev-2 next-2 prev-3 next-3 initial-state initial-active"
    );

    $(cards[currentCardIndex]).addClass("active");

    const prevIndex_1 = (currentCardIndex - 1 + totalCards) % totalCards;
    const nextIndex_1 = (currentCardIndex + 1) % totalCards;
    $(cards[prevIndex_1]).addClass("prev-1");
    $(cards[nextIndex_1]).addClass("next-1");

    const prevIndex_2 = (currentCardIndex - 2 + totalCards) % totalCards;
    const nextIndex_2 = (currentCardIndex + 2) % totalCards;
    $(cards[prevIndex_2]).addClass("prev-2");
    $(cards[nextIndex_2]).addClass("next-2");

    const prevIndex_3 = (currentCardIndex - 3 + totalCards) % totalCards;
    const nextIndex_3 = (currentCardIndex + 3) % totalCards;
    $(cards[prevIndex_3]).addClass("prev-3");
    $(cards[nextIndex_3]).addClass("next-3");
}
		// Handle card click - center the clicked card
		function handleCardClick(index) {
			currentCardIndex = index;
			updateCarousel();
		}

		// Initialize: Show first card, then animate to positions
		setInitialState();

		// Wait for page to fully load, then animate
		$(window).on("load", function () {
			setTimeout(function () {
				animateToPositions();
			}, 500); // Small delay after page load
		});

		// If page is already loaded
		if (document.readyState === "complete") {
			setTimeout(function () {
				animateToPositions();
			}, 500);
		}

		// Add click handlers to cards (desktop only)
		cards.each(function (index) {
			const $card = $(this);

			// Handle click/tap - only on desktop
			$card.on("click", function (e) {
				// Only allow card clicks on desktop (md and up)
				if (window.innerWidth >= 768) {
					// Don't trigger if clicking on the Explore button
					if (!$(e.target).closest(".btn-explore").length) {
						handleCardClick(index);
					}
				}
			});

			// Prevent card click when clicking on links/buttons
			$card.find("a, button").on("click", function (e) {
				e.stopPropagation();
			});
		});

		// Add arrow click handlers (mobile)
		$(".we-arrow-left").on("click", function () {
			currentCardIndex = (currentCardIndex - 1 + totalCards) % totalCards;
			updateCarousel();
		});

		$(".we-arrow-right").on("click", function () {
			currentCardIndex = (currentCardIndex + 1) % totalCards;
			updateCarousel();
		});
	}

	// Scroll down indicator functionality
	function initScrollIndicator() {
		$(".scroll-down-btn").on("click", function (e) {
			e.preventDefault();

			// Get the why-choose-us section
			const $whyChooseUs = $(".why_choose_us");
			const whyChooseUsBottom =
				$whyChooseUs.offset().top + $whyChooseUs.outerHeight();

			// Smooth scroll to next section after why-choose-us
			$("html, body").animate(
				{
					scrollTop: whyChooseUsBottom,
				},
				800,
				"swing"
			);
		});
	}

	// Events carousel initialization
	function initEventsCarousel() {
		const $eventsCarousel = $(".events-carousel");
		if (!$eventsCarousel.length) return;

		// Check if Owl Carousel is loaded
		if (typeof $.fn.owlCarousel === "undefined") {
			// Wait for Owl Carousel to load
			setTimeout(initEventsCarousel, 100);
			return;
		}

		$eventsCarousel.owlCarousel({
			loop: true,
			margin: 12,
			nav: true,
			dots: false,
			autoplay: false,
			navText: ["", ""],
			responsive: {
				0: {
					items: 1,
					margin: 5,
				},
				576: {
					items: 1.5,
					margin: 4,
				},
				768: {
					items: 2,
					margin: 4,
				},
				992: {
					items: 3,
					margin: 4,
				},
				1200: {
					items: 3.5,
					margin: 4,
				},
			},
		});
	}

	// Movements carousel initialization
	function initMovementsCarousel() {
		const $movementsCarousel = $(".movements-carousel");
		if (!$movementsCarousel.length) return;

		// Check if Owl Carousel is loaded
		if (typeof $.fn.owlCarousel === "undefined") {
			// Wait for Owl Carousel to load
			setTimeout(initMovementsCarousel, 100);
			return;
		}

		$movementsCarousel.owlCarousel({
			loop: true,
			margin: 20,
			nav: true,
			dots: false,
			autoplay: false,
			navText: ["", ""],
			responsive: {
				0: {
					items: 1,
					margin: 8,
				},
				576: {
					items: 1.5,
					margin: 15,
				},
				768: {
					items: 2,
					margin: 15,
				},
				992: {
					items: 3,
					margin: 20,
				},
				1200: {
					items: 4,
					margin: 20,
				},
			},
		});
	}

	// Destinations carousel initialization
	function initDestinationsCarousel() {
		const $destinationsCarousel = $(".destinations-carousel");
		if (!$destinationsCarousel.length) return;

		// Check if Owl Carousel is loaded
		if (typeof $.fn.owlCarousel === "undefined") {
			// Wait for Owl Carousel to load
			setTimeout(initDestinationsCarousel, 100);
			return;
		}

		$destinationsCarousel.owlCarousel({
			loop: true,
			margin: 20,
			nav: true,
			dots: false,
			autoplay: false,
			navText: ["", ""],
			responsive: {
				0: {
					items: 1,
					margin: 10,
				},
				576: {
					items: 1,
					margin: 15,
				},
				768: {
					items: 2,
					margin: 15,
				},
				992: {
					items: 2.5,
					margin: 20,
				},
				1200: {
					items: 3.5,
					margin: 20,
				},
			},
		});
	}

	// Movements video play functionality
	function initMovementsVideo() {
		const $momentCards = $(".moment_card");
		if (!$momentCards.length) return;

		$momentCards.each(function () {
			const $card = $(this);
			const $video = $card.find(".moment_video");
			const $playButton = $card.find(".play_button");
			const video = $video[0];

			if (!video) return;

			let isManuallyPlaying = false; // Track if user manually clicked play button
			let isHovering = false; // Track hover state

			// Ensure video shows first frame
			video.currentTime = 0;
			video.pause();
			updatePlayIcon(false);

			// Update play icon based on play state
			function updatePlayIcon(isPlaying) {
				const $icon = $playButton.find("i");
				if (isPlaying) {
					$icon.removeClass("ri-play-fill").addClass("ri-pause-fill");
				} else {
					$icon.removeClass("ri-pause-fill").addClass("ri-play-fill");
				}
			}

			// Play video on play button click/touch
			$playButton.on("click touchstart", function (e) {
				e.preventDefault();
				e.stopPropagation();

				if (video.paused) {
					isManuallyPlaying = true;
					video.play().catch(function (error) {
						console.log("Video play failed:", error);
					});
				} else {
					isManuallyPlaying = false;
					video.pause();
				}
			});

			// Play video on card hover (desktop)
			$card.on("mouseenter", function () {
				isHovering = true;
				if (!isManuallyPlaying && video.paused) {
					video.play().catch(function (error) {
						console.log("Video play failed:", error);
					});
				}
			});

			// Pause video when mouse leaves (desktop)
			$card.on("mouseleave", function () {
				isHovering = false;
				if (!isManuallyPlaying) {
					video.pause();
					video.currentTime = 0; // Reset to first frame
				}
			});

			// Touch events for mobile
			$card.on("touchstart", function () {
				isHovering = true;
				if (!isManuallyPlaying && video.paused) {
					video.play().catch(function (error) {
						console.log("Video play failed:", error);
					});
				}
			});

			$card.on("touchend touchcancel", function () {
				isHovering = false;
				if (!isManuallyPlaying) {
					video.pause();
					video.currentTime = 0; // Reset to first frame
				}
			});

			// Track play state and update icon
			video.addEventListener("play", function () {
				updatePlayIcon(true);
			});

			video.addEventListener("pause", function () {
				updatePlayIcon(false);
			});

			// Reset manual play state when video ends (if looping)
			video.addEventListener("ended", function () {
				if (!isHovering && !isManuallyPlaying) {
					video.currentTime = 0;
					video.pause();
				}
			});
		});
	}

	// Testimonials carousel initialization
	function initTestimonialsCarousel() {
		const $googleCarousel = $(".google-testimonials-carousel");
		const $facebookCarousel = $(".facebook-testimonials-carousel");

		// Check if Owl Carousel is loaded
		if (typeof $.fn.owlCarousel === "undefined") {
			// Wait for Owl Carousel to load
			setTimeout(initTestimonialsCarousel, 100);
			return;
		}

		// Initialize Google testimonials carousel
		if ($googleCarousel.length) {
			$googleCarousel.owlCarousel({
				loop: true,
				margin: 20,
				nav: true,
				dots: false,
				autoplay: false,
				navText: ["", ""],
				responsive: {
					0: {
						items: 1,
						margin: 10,
					},
					576: {
						items: 1.5,
						margin: 15,
					},
					768: {
						items: 2,
						margin: 20,
					},
					992: {
						items: 3,
						margin: 20,
					},
				},
			});
		}

		// Initialize Facebook testimonials carousel
		if ($facebookCarousel.length) {
			$facebookCarousel.owlCarousel({
				loop: true,
				margin: 20,
				nav: true,
				dots: false,
				autoplay: false,
				navText: ["", ""],
				responsive: {
					0: {
						items: 1,
						margin: 10,
					},
					576: {
						items: 1.5,
						margin: 15,
					},
					768: {
						items: 2,
						margin: 20,
					},
					992: {
						items: 3,
						margin: 20,
					},
				},
			});
		}
	}

	// Success testimonials carousel initialization
	function initSuccessTestimonialsCarousel() {
		const $successCarousel = $(".success-testimonials-carousel");
		if (!$successCarousel.length) return;

		// Check if Owl Carousel is loaded
		if (typeof $.fn.owlCarousel === "undefined") {
			// Wait for Owl Carousel to load
			setTimeout(initSuccessTestimonialsCarousel, 100);
			return;
		}

		$successCarousel.owlCarousel({
			loop: true,
			margin: 20,
			nav: false,
			dots: true,
			autoplay: false,
			responsive: {
				0: {
					items: 1,
					margin: 10,
				},
				576: {
					items: 1.5,
					margin: 15,
				},
				768: {
					items: 2,
					margin: 20,
				},
				992: {
					items: 3,
					margin: 20,
				},
			},
		});
	}
 
	 // Global Partners cursor interaction
	function initGlobalPartnersCursor() {
		const $logosWrapper = $(".logos_grid_wrapper");
		if (!$logosWrapper.length) return;

		const $logoTracks = $(".logo_track");
		const $logoItems = $(".logo_grid_item");
		if (!$logoItems.length) return;

		// Pause animation on hover — let CSS :hover handle play-state
		// Only add subtle scale on individual item hover, never touch translateY/X
		$logoItems.on("mouseenter", function () {
			// Pause the parent column's track animation smoothly
			$(this).closest(".logo_column").find(".logo_track").css({
				"animation-play-state": "paused",
			});
		});

		$logoItems.on("mouseleave", function () {
			// Resume animation
			$(this).closest(".logo_column").find(".logo_track").css({
				"animation-play-state": "running",
			});
		});
	}

	// Why Choose Us video autoplay
	function initWhyChooseVideo() {
		const $video = $(".why_choose_video");
		if (!$video.length) return;

		$video.each(function () {
			const video = this;

			// Ensure video autoplays
			const playPromise = video.play();

			if (playPromise !== undefined) {
				playPromise.catch(function (error) {
					// Autoplay was prevented, try again on user interaction
					$(document).one("click touchstart", function () {
						video.play().catch(function (err) {
							console.log("Video autoplay failed:", err);
						});
					});
				});
			}
		});
	}

	// Branches carousel with background transition
	function initBranchesCarousel() {
		const $branchesCarousel = $(".branches-carousel");
		if (!$branchesCarousel.length) return;

		// Check if Owl Carousel is loaded
		if (typeof $.fn.owlCarousel === "undefined") {
			// Wait for Owl Carousel to load
			setTimeout(initBranchesCarousel, 100);
			return;
		}

		// Add unique class to first carousel item
		const $firstItem = $branchesCarousel.find(".carousel_item").first();
		$firstItem.addClass("first-carousel-item");

		$branchesCarousel.owlCarousel({
			loop: true,
			margin: 10,
			nav: true,
			dots: false,
			autoplay: false,
			autoplayTimeout: 4000,
			autoplayHoverPause: true,
			autoplaySpeed: 800,
			navText: ["", ""],
			center: true,
			stagePadding: 0,
			responsive: {
				0: {
					items: 2,
					margin: 8,
					stagePadding: 0,
				},
				576: {
					items: 3,
					margin: 10,
					stagePadding: 0,
				},
				768: {
					items: 3,
					margin: 12,
					stagePadding: 0,
				},
				992: {
					items: 4,
					margin: 15,
					stagePadding: 0,
				},
			},
		});

		// Handle background image transition
		const $bgImages = $(
			".branches_section .background_image_wrapper .bg_image"
		);
		const $bgImageWrapper = $(".branches_section .background_image_wrapper");

		// Handle text content updates
		const $subtitle = $(".branches_section .section_subtitle");
		const $description = $(".branches_section .section_description");
		const $directionsBtn = $(".branches_section .btn_directions");

		function updateBranchContent() {
			// Get the center/active carousel item (Owl Carousel centers the active item)
			const $activeItem = $branchesCarousel
				.find(".owl-item.active.center .carousel_item")
				.first();

			// Fallback to just active if center class not available
			const $centerItem = $activeItem.length
				? $activeItem
				: $branchesCarousel.find(".owl-item.active .carousel_item").first();

			if ($centerItem.length) {
				// Get branch data from data attributes
				const subtitle = $centerItem.data("branch-subtitle") || "";
				const description = $centerItem.data("branch-description") || "";
				const directionsUrl = $centerItem.data("branch-directions") || "#";

				// Update text content with smooth slide and fade animation
				if ($subtitle.length && subtitle) {
					$subtitle
						.off("transitionend.branchContent")
						.addClass("content-fade-out")
						.one("transitionend.branchContent", function () {
							const $el = $(this);
							$el.removeClass("content-fade-out").text(subtitle);
							// Force reflow to ensure transition works
							$el[0].offsetHeight;
							$el.addClass("content-fade-in");
							setTimeout(() => {
								$el.removeClass("content-fade-in");
							}, 300);
						});
				}

				if ($description.length && description) {
					$description
						.off("transitionend.branchContent")
						.addClass("content-fade-out")
						.one("transitionend.branchContent", function () {
							const $el = $(this);
							$el.removeClass("content-fade-out").html(description);
							// Force reflow to ensure transition works
							$el[0].offsetHeight;
							$el.addClass("content-fade-in");
							setTimeout(() => {
								$el.removeClass("content-fade-in");
							}, 300);
						});
				}

				if ($directionsBtn.length && directionsUrl) {
					$directionsBtn
						.off("transitionend.branchContent")
						.addClass("content-fade-out")
						.one("transitionend.branchContent", function () {
							const $el = $(this);
							$el.removeClass("content-fade-out").attr("href", directionsUrl);
							// Force reflow to ensure transition works
							$el[0].offsetHeight;
							$el.addClass("content-fade-in");
							setTimeout(() => {
								$el.removeClass("content-fade-in");
							}, 300);
						});
				}
			}
		}

		function updateBackgroundImage() {
			// Get the center/active carousel item (Owl Carousel centers the active item)
			const $activeItem = $branchesCarousel
				.find(".owl-item.active.center .carousel_item")
				.first();

			// Fallback to just active if center class not available
			const $centerItem = $activeItem.length
				? $activeItem
				: $branchesCarousel.find(".owl-item.active .carousel_item").first();

			if ($centerItem.length) {
				// Get the image src from the center/active carousel item
				const $centerImage = $centerItem.find("img");
				const centerImageSrc = $centerImage.attr("src");

				if (centerImageSrc) {
					// Find background image with this src
					let $targetBgImage = $bgImages.filter(function () {
						return $(this).attr("src") === centerImageSrc;
					});

					// If no background image with this src exists, update the first one
					if (!$targetBgImage.length) {
						$targetBgImage = $bgImages.first();
						$targetBgImage.attr("src", centerImageSrc);
					}

					// Update background images - hide all, show matching one
					$bgImages.removeClass("active");
					$targetBgImage.addClass("active");
				}
			}
		}

		// Initialize background with center/active carousel item's image
		function initializeBackground() {
			// Wait for carousel to initialize, then get the center item
			setTimeout(function () {
				const $centerItem = $branchesCarousel
					.find(".owl-item.active.center .carousel_item")
					.first();

				// Fallback to first item or active item
				const $targetItem = $centerItem.length
					? $centerItem
					: $branchesCarousel
							.find(".carousel_item.first-carousel-item")
							.first() ||
					  $branchesCarousel.find(".owl-item.active .carousel_item").first();

				if ($targetItem.length) {
					const $targetImage = $targetItem.find("img");
					const targetImageSrc = $targetImage.attr("src");

					if (targetImageSrc && $bgImages.length > 0) {
						// Set background image to match center/active carousel item
						$bgImages.first().attr("src", targetImageSrc).addClass("active");
					}

					// Initialize text content
					updateBranchContent();
				}
			}, 100);
		}

		// Listen to carousel change events (works for both autoplay and manual navigation)
		$branchesCarousel.on("changed.owl.carousel", function (event) {
			updateBackgroundImage();
			updateBranchContent();
		});

		// Also listen to translated event for better compatibility
		$branchesCarousel.on("translated.owl.carousel", function (event) {
			updateBackgroundImage();
			updateBranchContent();
		});

		// Initialize background with center/active carousel item's image
		setTimeout(function () {
			initializeBackground();
			// Then update to active item
			updateBackgroundImage();
			updateBranchContent();
		}, 200);
	}

	// Partner Universities carousel with background and title transition
	function initPartnerUniversitiesCarousel() {
		const $partnerCarousel = $(".partner-universities-carousel");
		if (!$partnerCarousel.length) return;

		// Check if Owl Carousel is loaded
		if (typeof $.fn.owlCarousel === "undefined") {
			// Wait for Owl Carousel to load
			setTimeout(initPartnerUniversitiesCarousel, 100);
			return;
		}

		// Add unique class to first carousel item
		const $firstItem = $partnerCarousel.find(".carousel_item").first();
		$firstItem.addClass("first-carousel-item");

		$partnerCarousel.owlCarousel({
			loop: true,
			margin: 10,
			nav: true,
			dots: false,
			autoplay: true,
			autoplayTimeout: 4000,
			autoplayHoverPause: true,
			autoplaySpeed: 800,
			navText: ["", ""],
			center: true,
			stagePadding: 0,
			responsive: {
				0: {
					items: 2,
					margin: 8,
					stagePadding: 0,
				},
				576: {
					items: 3,
					margin: 10,
					stagePadding: 0,
				},
				768: {
					items: 3,
					margin: 12,
					stagePadding: 0,
				},
				992: {
					items: 4,
					margin: 15,
					stagePadding: 0,
				},
			},
		});

		// Handle background image and title transition
		const $bgImages = $(
			".partner_universities_section .background_image_wrapper .bg_image"
		);
		const $universityName = $(".partner_universities_section .university_name");

		function updateContent() {
			// Get the center/active carousel item
			const $activeItem = $partnerCarousel
				.find(".owl-item.active.center .carousel_item")
				.first();

			// Fallback to just active if center class not available
			const $centerItem = $activeItem.length
				? $activeItem
				: $partnerCarousel.find(".owl-item.active .carousel_item").first();

			if ($centerItem.length) {
				// Get the image src and university name from the center/active carousel item
				const $centerImage = $centerItem.find("img");
				const centerImageSrc = $centerImage.attr("src");
				const uniIndex = $centerItem.data("uni-index");
				const uniName = $centerItem.data("uni-name");

				if (centerImageSrc) {
					// Find background image with matching data-uni-index
					let $targetBgImage = $bgImages.filter(
						`[data-uni-index="${uniIndex}"]`
					);

					// If no background image with this index exists, update the first one
					if (!$targetBgImage.length) {
						$targetBgImage = $bgImages.first();
						$targetBgImage.attr("src", centerImageSrc);
					}

					// Update background images - hide all, show matching one
					$bgImages.removeClass("active");
					$targetBgImage.addClass("active");

					// Update university name with smooth transition
					if (uniName && $universityName.length) {
						// Fade out
						$universityName.addClass("fade-out");

						setTimeout(function () {
							// Update text
							$universityName
								.text(uniName)
								.removeClass("fade-out")
								.addClass("fade-in");

							// Remove fade-in class after animation
							setTimeout(function () {
								$universityName.removeClass("fade-in");
							}, 500);
						}, 250);
					}
				}
			}
		}

		// Initialize background and title with center/active carousel item
		function initializeContent() {
			// Wait for carousel to initialize, then get the center item
			setTimeout(function () {
				const $centerItem = $partnerCarousel
					.find(".owl-item.active.center .carousel_item")
					.first();

				// Fallback to first item or active item
				const $targetItem = $centerItem.length
					? $centerItem
					: $partnerCarousel
							.find(".carousel_item.first-carousel-item")
							.first() ||
					  $partnerCarousel.find(".owl-item.active .carousel_item").first();

				if ($targetItem.length) {
					const $targetImage = $targetItem.find("img");
					const targetImageSrc = $targetImage.attr("src");
					const uniIndex = $targetItem.data("uni-index");
					const uniName = $targetItem.data("uni-name");

					if (targetImageSrc && $bgImages.length > 0) {
						// Set background image to match center/active carousel item
						const $targetBgImage = $bgImages.filter(
							`[data-uni-index="${uniIndex}"]`
						);
						if ($targetBgImage.length) {
							$targetBgImage.addClass("active");
						} else {
							$bgImages.first().attr("src", targetImageSrc).addClass("active");
						}
					}

					// Set initial university name
					if (uniName && $universityName.length) {
						$universityName.text(uniName);
					}
				}
			}, 100);
		}

		// Listen to carousel change events
		$partnerCarousel.on("changed.owl.carousel", function (event) {
			updateContent();
		});

		// Also listen to translated event for better compatibility
		$partnerCarousel.on("translated.owl.carousel", function (event) {
			updateContent();
		});

		// Initialize content with center/active carousel item
		setTimeout(function () {
			initializeContent();
			// Then update to active item
			updateContent();
		}, 200);
	}

	// Scholarship Opportunities carousel initialization
	function initScholarshipCarousel() {
		const $scholarshipCarousel = $(".scholarship-carousel");
		if (!$scholarshipCarousel.length) return;

		// Check if Owl Carousel is loaded
		if (typeof $.fn.owlCarousel === "undefined") {
			// Wait for Owl Carousel to load
			setTimeout(initScholarshipCarousel, 100);
			return;
		}

		$scholarshipCarousel.owlCarousel({
			loop: true,
			margin: 0,
			nav: false,
			dots: true,
			autoplay: false,
			autoplayTimeout: 4000,
			autoplayHoverPause: true,
			autoplaySpeed: 800,
			navText: ["", ""],
			center: true,
			responsive: {
				0: {
					items: 1,
					margin: 0,
					center: false,
				},
				576: {
					items: 1.5,
					margin: 0,
					center: true,
				},
				768: {
					items: 2,
					margin: 0,
					center: true,
				},
				992: {
					items: 3,
					margin: 0,
					center: true,
				},
			},
		});

		// Prevent click on cards without links
		$scholarshipCarousel.on("click", ".scholarship_card.no-link", function (e) {
			e.preventDefault();
			e.stopPropagation();
			return false;
		});
	}

	// Announcements carousel initialization
	function initAnnouncementsCarousel() {
		const $announcementsCarousel = $(".announcements-carousel");
		if (!$announcementsCarousel.length) return;

		// Check if Owl Carousel is loaded
		if (typeof $.fn.owlCarousel === "undefined") {
			// Wait for Owl Carousel to load
			setTimeout(initAnnouncementsCarousel, 100);
			return;
		}

		$announcementsCarousel.owlCarousel({
			loop: true,
			margin: 0,
			nav: false,
			dots: true,
			autoplay: false,
			autoplayTimeout: 4000,
			autoplayHoverPause: true,
			autoplaySpeed: 800,
			navText: ["", ""],
			center: true,
			responsive: {
				0: {
					items: 1,
					margin: 0,
					center: false,
				},
				576: {
					items: 1.5,
					margin: 0,
					center: true,
				},
				768: {
					items: 2,
					margin: 0,
					center: true,
				},
				992: {
					items: 3,
					margin: 0,
					center: true,
				},
			},
		});

		// Prevent click on cards without links
		$announcementsCarousel.on(
			"click",
			".announcement_card.no-link",
			function (e) {
				e.preventDefault();
				e.stopPropagation();
				return false;
			}
		);
	}

	// Factors carousel initialization (mobile only)
	function initFactorsCarousel() {
		const $factorsCarousel = $(".factors-carousel");
		if (!$factorsCarousel.length) return;

		// Check if Owl Carousel is loaded
		if (typeof $.fn.owlCarousel === "undefined") {
			// Wait for Owl Carousel to load
			setTimeout(initFactorsCarousel, 100);
			return;
		}

		$factorsCarousel.owlCarousel({
			loop: true,
			margin: 20,
			nav: true,
			dots: true,
			autoplay: false,
			autoplayTimeout: 4000,
			autoplayHoverPause: true,
			autoplaySpeed: 800,
			navText: ["", ""],
			center: false,
			responsive: {
				0: {
					items: 1,
					margin: 10,
					nav: true,
					dots: true,
				},
				576: {
					items: 2,
					margin: 15,
					nav: true,
					dots: true,
				},
				768: {
					items: 2,
					margin: 20,
					nav: false,
					dots: true,
				},
			},
		});
	}

	// Visa Updates carousel initialization
	function initVisaUpdatesCarousel() {
		const $visaCarousel = $(".visa-updates-carousel");
		if (!$visaCarousel.length) return;

		// Check if Owl Carousel is loaded
		if (typeof $.fn.owlCarousel === "undefined") {
			// Wait for Owl Carousel to load
			setTimeout(initVisaUpdatesCarousel, 100);
			return;
		}

		// Count number of cards
		const cardCount = $visaCarousel.find(".visa_card").length;
		const $grid = $(".visa_cards_grid");
		const $carouselWrapper = $(".visa_carousel_wrapper");

		// Show/hide grid and carousel based on card count
		if (cardCount > 4) {
			// More than 4 cards: show carousel on desktop, hide grid
			$grid.addClass("has-more-cards");
			$carouselWrapper.addClass("show-on-desktop");
		} else {
			// 4 or fewer cards: show grid on desktop, hide carousel
			$grid.removeClass("has-more-cards");
			$carouselWrapper.removeClass("show-on-desktop");
		}

		// Initialize carousel for mobile or if more than 4 cards
		if (cardCount > 4 || window.innerWidth <= 991) {
			$visaCarousel.owlCarousel({
				loop: cardCount > 4,
				margin: 20,
				nav: cardCount > 4,
				dots: true,
				autoplay: false,
				autoplayTimeout: 4000,
				autoplayHoverPause: true,
				autoplaySpeed: 800,
				navText: ["", ""],
				center: false,
				responsive: {
					0: {
						items: 1,
						margin: 10,
						nav: true,
						dots: true,
					},
					576: {
						items: 2,
						margin: 15,
						nav: true,
						dots: true,
					},
					768: {
						items: 2,
						margin: 20,
						nav: cardCount > 4,
						dots: true,
					},
					992: {
						items: 4,
						margin: 24,
						nav: cardCount > 4,
						dots: cardCount > 4,
					},
				},
			});
		}

		// Handle window resize
		$(window).on("resize", function () {
			if (window.innerWidth <= 991 && !$visaCarousel.data("owl.carousel")) {
				// Reinitialize on mobile if not already initialized
				initVisaUpdatesCarousel();
			}
		});
	}

	// Social Media Testimonials Dual Carousels (Continuous Smooth Movement)
	function initSocialTestimonialsCarousels() {
		const $leftCarousel = $(".social-testimonials-carousel-left");
		const $rightCarousel = $(".social-testimonials-carousel-right");

		if (!$leftCarousel.length && !$rightCarousel.length) return;

		// Check if Owl Carousel is loaded
		if (typeof $.fn.owlCarousel === "undefined") {
			// Wait for Owl Carousel to load
			setTimeout(initSocialTestimonialsCarousels, 100);
			return;
		}

		// Initialize Left Carousel (moves forward/left)
		if ($leftCarousel.length) {
			$leftCarousel.owlCarousel({
				loop: true,
				margin: 20,
				nav: false,
				dots: false,
				autoplay: true,
				autoplayTimeout: 3000, // Smooth continuous movement
				autoplayHoverPause: false, // Don't pause on hover for continuous movement
				autoplaySpeed: 1500, // Smooth transition speed
				smartSpeed: 1500,
				navText: ["", ""],
				stagePadding: 50, // Add padding to show partial items on edges
				responsive: {
					0: {
						items: 1,
						margin: 10,
						stagePadding: 0,
					},
					576: {
						items: 1.5,
						margin: 15,
						stagePadding: 30,
					},
					768: {
						items: 2,
						margin: 20,
						stagePadding: 40,
					},
					992: {
						items: 3,
						margin: 20,
						stagePadding: 50,
					},
					1200: {
						items: 3,
						margin: 20,
						stagePadding: 60,
					},
				},
			});
		}

		// Initialize Right Carousel (moves backward/right to left)
		if ($rightCarousel.length) {
			$rightCarousel.owlCarousel({
				loop: true,
				margin: 20,
				nav: false,
				dots: false,
				autoplay: false, // We'll manually control this for reverse movement
				autoplayTimeout: 3000,
				autoplayHoverPause: false,
				autoplaySpeed: 1500,
				smartSpeed: 1500,
				navText: ["", ""],
				stagePadding: 50, // Add padding to show partial items on edges
				responsive: {
					0: {
						items: 1,
						margin: 10,
						stagePadding: 0,
					},
					576: {
						items: 1.5,
						margin: 15,
						stagePadding: 30,
					},
					768: {
						items: 2,
						margin: 20,
						stagePadding: 40,
					},
					992: {
						items: 3,
						margin: 20,
						stagePadding: 50,
					},
					1200: {
						items: 3,
						margin: 20,
						stagePadding: 60,
					},
				},
			});

			// Continuously move right carousel backwards (right to left) using setInterval
			let rightCarouselInterval = null;

			// Start movement after carousel is ready
			setTimeout(function () {
				if ($rightCarousel.data("owl.carousel")) {
					// Clear any existing interval
					if (rightCarouselInterval) {
						clearInterval(rightCarouselInterval);
					}

					// Start reverse movement (right to left)
					rightCarouselInterval = setInterval(function () {
						if ($rightCarousel.length && $rightCarousel.data("owl.carousel")) {
							$rightCarousel.trigger("prev.owl.carousel");
						} else {
							if (rightCarouselInterval) {
								clearInterval(rightCarouselInterval);
								rightCarouselInterval = null;
							}
						}
					}, 3000);
				}
			}, 500);

			// Also listen to initialized event as backup
			$rightCarousel.on("initialized.owl.carousel", function () {
				setTimeout(function () {
					if (!rightCarouselInterval && $rightCarousel.data("owl.carousel")) {
						rightCarouselInterval = setInterval(function () {
							if (
								$rightCarousel.length &&
								$rightCarousel.data("owl.carousel")
							) {
								$rightCarousel.trigger("prev.owl.carousel");
							} else {
								if (rightCarouselInterval) {
									clearInterval(rightCarouselInterval);
									rightCarouselInterval = null;
								}
							}
						}, 3000);
					}
				}, 100);
			});

			// Clean up interval on destroy
			$rightCarousel.on("destroy.owl.carousel", function () {
				if (rightCarouselInterval) {
					clearInterval(rightCarouselInterval);
					rightCarouselInterval = null;
				}
			});
		}
	}

	$(document).ready(function () {
		initHeaderScroll();
		initCarousel();
		initScrollIndicator();
		initGlobalPartnersCursor();
		initMovementsVideo();
		initWhyChooseVideo();

		// Initialize events carousel after a short delay to ensure Owl Carousel is loaded
		setTimeout(function () {
			initEventsCarousel();
			initMovementsCarousel();
			initTestimonialsCarousel();
			initBranchesCarousel();
			initDestinationsCarousel();
			initSuccessTestimonialsCarousel();
			initPartnerUniversitiesCarousel();
			initScholarshipCarousel();
			initAnnouncementsCarousel();
			initFactorsCarousel();
			initVisaUpdatesCarousel();
			initSocialTestimonialsCarousels();
		}, 100);
	});
})(jQuery);

